import {
    FETCH_REFERENCES_REQUEST,
    FETCH_REFERENCES_SUCCESS,
    FETCH_REFERENCES_FAILURE,
    ADD_REFERENCE_REQUEST,
    ADD_REFERENCE_SUCCESS,
    ADD_REFERENCE_FAILURE,
  } from '../../actions';
  
  const initialState = {
    list: [],
    isLoading: false,
    error: null
  };
  
  function referencesReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_REFERENCES_REQUEST:
      case ADD_REFERENCE_REQUEST:
        return {
          ...state,
          isLoading: true,
          error: null,
        };
  
      case FETCH_REFERENCES_SUCCESS:
        return {
          ...state,
          isLoading: false,
          list: action.payload,
        };
  
      case ADD_REFERENCE_SUCCESS:
        return {
          ...state,
          isLoading: false,
        };
  
      case FETCH_REFERENCES_FAILURE:
      case ADD_REFERENCE_FAILURE:
        return {
          ...state,
          isLoading: false,
          error: action.error,
        };
  
      default:
        return state;
    }
  }
  
  export default referencesReducer;
  